/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { PromotionPricingResponseDTOFromJSON, PromotionPricingUpdateDTOToJSON, } from '../models/index';
/**
 *
 */
export class PromotionPricingControllerApi extends runtime.BaseAPI {
    /**
     */
    async getPromotionPricingRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling getPromotionPricing().');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/{marketplace}/promotion-pricing`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionPricingResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async getPromotionPricing(requestParameters, initOverrides) {
        const response = await this.getPromotionPricingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     */
    async updatePromotionPricingRaw(requestParameters, initOverrides) {
        if (requestParameters['marketplace'] == null) {
            throw new runtime.RequiredError('marketplace', 'Required parameter "marketplace" was null or undefined when calling updatePromotionPricing().');
        }
        if (requestParameters['promotionPricingUpdateDTO'] == null) {
            throw new runtime.RequiredError('promotionPricingUpdateDTO', 'Required parameter "promotionPricingUpdateDTO" was null or undefined when calling updatePromotionPricing().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/api/marketplace/{marketplace}/promotion-pricing`;
        urlPath = urlPath.replace(`{${"marketplace"}}`, encodeURIComponent(String(requestParameters['marketplace'])));
        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PromotionPricingUpdateDTOToJSON(requestParameters['promotionPricingUpdateDTO']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => PromotionPricingResponseDTOFromJSON(jsonValue));
    }
    /**
     */
    async updatePromotionPricing(requestParameters, initOverrides) {
        const response = await this.updatePromotionPricingRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
/**
 * @export
 */
export const GetPromotionPricingMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const UpdatePromotionPricingMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
